import TripCard from './src/TripCard';
export default TripCard;